import { getAppScheme } from '@utils/nativeUtils';
import { useEffect, useState } from 'react';

import useNativeListener from './useNativeListener';

function useAppScheme() {
    const [appScheme, setAppScheme] = useState<string>();
    useEffect(() => {
        getAppScheme();
    }, []);

    useNativeListener('getAppScheme', (url: string) => {
        setAppScheme(url);
    });

    return appScheme;
}

export default useAppScheme;
